import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Button,
} from "@mui/material";

export default function ReferralCodeDialog({
  open,
  onClose,
  referralCode,
  setReferralCode,
  onAdd,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="referral-dialog-title"
      aria-describedby="referral-dialog-description"
    >
      <DialogTitle id="referral-dialog-title">Referral Code</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12} sx={{ m: 0, p: 1 }}>
            <TextField
              id="referralCode"
              label="Referral Code"
              fullWidth
              value={referralCode}
              variant="standard"
              onChange={(e) => setReferralCode(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onAdd} autoFocus disabled={referralCode.length < 3}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
